export class CreateUserRequestSimple{
    constructor({customText,email,sendEmail,firstName,lastName}) {
        this.customText=customText;
        this.firstName=firstName;
        this.lastName=lastName;
        this.email=email;
        this.sendEmail=sendEmail;
    }
}